import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"vertical-align":"middle"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"vertical-align":"middle"} }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { style: {"height":"100%"} }
const _hoisted_8 = { style: {"width":"100%"} }
const _hoisted_9 = { style: {"width":"100%","margin-bottom":"8px"} }
const _hoisted_10 = {
  key: 0,
  style: {"margin-right":"4px"}
}
const _hoisted_11 = { style: {"margin":"0","font-size":"0.8em","line-height":"1.2"} }
const _hoisted_12 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_13 = {
  key: 0,
  class: "ad-banner"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "compact-chips",
  style: {"max-height":"10vh","overflow-y":"scroll","margin-bottom":"4px"}
}
const _hoisted_18 = { class: "compact-chips" }
const _hoisted_19 = {
  class: "compact-chips",
  style: {"max-height":"10vh","overflow-y":"scroll","margin-bottom":"4px"}
}
const _hoisted_20 = { class: "compact-chips" }

import { ref, defineComponent, computed, onMounted, watch, reactive, } from 'vue';

// icons
import { add, close, checkmark, arrowUp,  arrowForward, arrowBack, checkbox, trashOutline,
         thumbsUpOutline, thumbsDownOutline, thumbsUp, thumbsDown, heart, heartOutline,
         chevronBack, chevronForward, repeat, search, flagOutline, logoWhatsapp, ellipse, } from 'ionicons/icons';

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonFooter, IonRow, IonCol, IonAccordion, IonAccordionGroup,
        IonItem, IonLabel, IonIcon, IonButtons, IonButton, IonReorderGroup, IonReorder, IonProgressBar,
        IonSearchbar, IonSegment, IonSegmentButton, IonList, IonSelect, IonSelectOption, IonSpinner, IonListHeader,
        IonCard, IonCardHeader, IonCardSubtitle, IonCardContent, IonChip, IonText, IonCardTitle, IonGrid, IonRippleEffect,
        IonNote, IonTextarea, IonFab, IonFabButton, IonBadge, IonInfiniteScroll, IonInfiniteScrollContent, IonModal, IonAvatar,
        IonicSlides, isPlatform, getPlatforms, modalController, loadingController, } from '@ionic/vue';
import ProgramInfoStats from '@/components/achievejupas/ProgramInfoStats.vue';
import ProgramItemContent from '@/components/achievejupas/ProgramItemContent.vue';
import SubjectScoreInputSection from '@/components/achievejupas/SubjectScoreInputSection.vue';
import ProgramIssueReportModal from '@/components/achievejupas/ProgramIssueReportModal.vue';

// Swiper
import 'swiper/swiper.min.css';
import 'swiper/modules/effect-cards/effect-cards.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import '@ionic/vue/css/ionic-swiper.css';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { EffectCards, Navigation, Virtual, } from 'swiper';

// composables / services
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';
import { useStore } from '@/store';
import { Institution, Program, Service, UserClaim, UserProgram } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ABProgramDeckModal',
  props: [
  "isAB3", "isGPT", "targetDiscipline", "prefilledPrograms", "oldUserPrograms",
  "showFirstProgramId", "singleSelectMode",
  "prefilledDisciplines", "oldUserDisciplines",
  "targetUser", "isDemo", "readonly",
],
  setup(__props) {

// Vue reactivity
const props = __props
// methods or filters
const store = useStore();
const { closeModal, doReorder, openModal, navigateMaterialCategories, getProxyImgLink,
        processUserItems, setUserItemReaction, isItemSelected, isItemDisliked, isMobileWeb,
        onThumbsUpItem, onThumbsDownItem, onClickMoreBtn, onClickPrevBtn, animateToFirstCard,
        recordCurrSlideReaction, resetActiveSlide, syncChosenItems, resetFilters, focusKeywordSearchbar,
        openImageModal, presentPrompt, sleep, htmlToPlainText, presentAlert, getBandLabel, getBandClass, openServiceModal,
        isMeetProgramElectiveRequirements, getUserSubjects, isAchievableProgram, getScoreDiff,
        isMeetUniEntranceRequirements, calculateSumWeightedScores, getFormattedGrade, getDSEScore, } = utils();
const { t } = useI18n();

const searchKeyword = ref("");
const isSearching = ref(false);
const delayLoading = ref(true);

// Report Modal
const showReportModal = ref(false);
const selectedProgramForReport = ref(null);
const openReportModal = (program) => {
  selectedProgramForReport.value = program;
  showReportModal.value = true;
};

// Store
const loggedInUser = computed(() => store.state.user);
const user = computed(() => props.targetUser || store.state.user);
const disciplineGroups = computed(() => store.state.allDisciplineGroups);
const disciplines = computed(() => store.state.allDisciplines); // for discipline tab
const relatedInstitutions = ref<Institution[]>([]);
const allPrograms = ref<Program[]>([]);
const chosenPrograms = ref<Program[]>(props.prefilledPrograms || []);
const userPrograms = ref<UserProgram[]>(props.oldUserPrograms || []);
const tmpNewUserPrograms = ref<UserProgram[]>([]); // for storing slideChange reaction
const takenActions = ref(false);

// TODO: Work Events (implanted promotion)
const workServices = computed<Service[]>(() => store.getters.getServicesByTypes(["Work"]));

// client programs
const advertisements = computed(() => store.state.allAdvertisements);

// filters
const selectedFilterGroup = ref('disciplines');
const selectedOption = ref<any>(props.isAB3 ? 'all' : 'highlight');
const nestedOption = ref('all'); // for nested filters for institutions
const settings = computed(() => store.state.settings);

const getAppState = () => ({
  selectedFilterGroup: selectedFilterGroup.value,
  selectedOption: selectedOption.value,
  searchKeyword: searchKeyword.value,
});
const confirmSelect = async (leaveWithoutSave = false) => {
  if (leaveWithoutSave) {
    if (takenActions.value) {
      await presentPrompt(`當前操作未儲存，確認要離開嗎?<br />Are you sure to leave without saving?`, async () => {
        await closeModal({});
      }, "注意 Attention");
    } else {
        await closeModal({});
    }
  } else {
    let newUserItems = processUserItems(chosenPrograms.value, userPrograms.value, tmpNewUserPrograms.value, 'programId', store.state.user.id);
    if (props.targetDiscipline?.id) {
      newUserItems = newUserItems.map(ui => ({ ...ui, disciplineId: props.targetDiscipline.id })); // link to related discipline
    }
    const loading = await loadingController.create({});
    await loading.present();
    await sleep(1);
    loading.dismiss();

    await closeModal({ "chosen": chosenPrograms.value, "userPrograms": newUserItems, }); // return selected program & order here
  }
};

// Helper functions for program reaction
const setReaction = (programId: any, reaction: any, skipIfExists = false) => {
  setUserItemReaction(programId, reaction, 'programId', userPrograms, tmpNewUserPrograms, getAppState(), skipIfExists);
}
const isSelected = (program: any) => (isItemSelected(program, chosenPrograms));
const isDisliked = (program: any) => (isItemDisliked(program, 'programId', userPrograms));

const startIdx = ref(0); // for card slides

const recordActiveSlideReaction = () => {
  setTimeout(() => {
    const slides: any = document.querySelector('#card-swiper-slides');
    if (slides) {
      const programId = slides.swiper.visibleSlides[0]?.dataset['programId'];
    }
  }, 200);
}
const initSlideListener = (reset = false) => {
  setTimeout(() => {
    // Init card slides
    delayLoading.value = false;
    setTimeout(() => {
      const slides: any = document.querySelector('#card-swiper-slides');
      if (slides) {
        slides.swiper.off('slideChange', recordActiveSlideReaction);
        slides.swiper.on('slideChange', recordActiveSlideReaction);
        recordActiveSlideReaction(); // initial slide
      }
    }, 200);
  }, 200);

  if (reset) resetActiveSlide(startIdx, delayLoading, 'programId', userPrograms, tmpNewUserPrograms, getAppState());
}

// INIT
onMounted(() => {
  const { targetDiscipline, showFirstProgramId, } = props;
  if (targetDiscipline) {
    // AB3
    relatedInstitutions.value = store.getters.getInstitutionsByDisciplineId(targetDiscipline.id, true);
    allPrograms.value = store.getters.getProgramsByDisciplineId(targetDiscipline.id, true);
  } else {
    // Mock JUPAS
    relatedInstitutions.value = store.getters.getInstitutionsByProgramType('jupas'); // only JUPAS intitutions
    allPrograms.value = store.getters.getProgramsByType('jupas'); // JUPAS programs
  }
  if (showFirstProgramId) {
    selectedOption.value = 'all';
    allPrograms.value = [
      ...allPrograms.value.filter(p => p.id == showFirstProgramId),
      ...allPrograms.value.filter(p => p.id != showFirstProgramId),
    ]
  }
  syncChosenItems('programId', chosenPrograms, userPrograms, allPrograms.value);
  initSlideListener();
})
watch(selectedOption, () => {
  initSlideListener();
  if (selectedFilterGroup.value == 'disciplines') {
    nestedOption.value = 'all'; // discipline groups changed
  }
})
watch(nestedOption, () => {
  initSlideListener(true);
})
watch(selectedFilterGroup, (currGroup) => {
  if (['like', 'dislike'].includes(currGroup)) {
    selectedOption.value = currGroup;
  }
  else if (currGroup == 'random') {
    resetFilters(selectedFilterGroup, selectedOption);
    allPrograms.value = store.getters.shuffledPrograms;
    animateToFirstCard();
  }
  else if (currGroup == 'search') {
    resetFilters(selectedFilterGroup, selectedOption);
    focusKeywordSearchbar(isSearching);
  }
  else {
    if (currGroup == 'institutions') { // Mock JUPAS: first show highlight programs
      selectedOption.value = relatedInstitutions.value[0];
    }
    else if (currGroup == 'disciplines') {
      selectedOption.value = 'highlight';
      //selectedOption.value = disciplines.value[0];
    }
    nestedOption.value = 'all'; // reset filter
  }
})

const onThumbsUp = (program: any) => {
  if (props.singleSelectMode) {
    return closeModal({ selectedProgram: program }); // choose & leave
  }
  onThumbsUpItem(program, 'programId', chosenPrograms, userPrograms, tmpNewUserPrograms, getAppState())
  takenActions.value = true;
}
const onThumbsDown = (program: any) => {
  onThumbsDownItem(program, 'programId', chosenPrograms, userPrograms, tmpNewUserPrograms, getAppState())
  takenActions.value = true;
}

// Show program by predicted scores
const selectedPredictScoreFilter = ref("all"); // all / self predict / school predict / self predict + 1
const plusOneSubjectId = ref<any>(24); // predicted score + 1 (default is Chinese)

// When subject score + 1
const subjectScorePlusOneExtraPrograms = computed(() => {
  const { allSubjects } = store.state;
  const userObj = props.targetUser || user.value;
  const userSubjects = getUserSubjects(allSubjects, userObj);
  const userSubjectGrades = (userObj.userSubjectGrades || []).filter(usg => usg.source == 'overallTarget'); // only consider self-predict grade

  // Current achievable programs
  const currAchievablePrograms = allPrograms.value.filter(p => isAchievableProgram(p, allSubjects, userSubjects, userSubjectGrades, 'overallTarget')).slice();

  // Get list of extra programs for each subject when grade + 1
  const resObj = {}; // { <subjectId>: [extra programs] }
  for (const usg of userSubjectGrades) {
    const newSubjectGrade = getFormattedGrade(Math.min(7, getDSEScore({}, usg.grade)+1));
    const newUserSubjectGrades = [...userSubjectGrades.filter(x => x.subjectId != usg.subjectId), { ...usg, grade: newSubjectGrade?.toString() }];
    
    const resPrograms = allPrograms.value.filter(p => isAchievableProgram(p, allSubjects, userSubjects, newUserSubjectGrades, 'overallTarget'));
    resObj[usg.subjectId] = resPrograms.filter(np => !currAchievablePrograms.find(p => p.id == np.id)); // extra programs
  }
  return resObj;
})
const plusOneSubjectIdChanged = (newSubjectId) => {
  plusOneSubjectId.value = newSubjectId;
}

// Achievable Programs
const achievablePrograms = computed(() => {
  const { allSubjects } = store.state;
  const userObj = props.targetUser || user.value;
  const userSubjects = getUserSubjects(allSubjects, userObj);
  const userSubjectGrades = userObj.userSubjectGrades || [];
  const filterVal = selectedPredictScoreFilter.value;
  if (filterVal == 'all') return allPrograms.value;
  if (filterVal == 'achievableSelfPredict') return allPrograms.value.filter(p => isAchievableProgram(p, allSubjects, userSubjects, userSubjectGrades, 'overallTarget'));
  if (filterVal == 'achievableSchoolPredict') return allPrograms.value.filter(p => isAchievableProgram(p, allSubjects, userSubjects, userSubjectGrades, 'schoolPredict'));
  if (filterVal == 'achievableSelfPredict+1') {
    if (plusOneSubjectId.value != null) {
      console.log(subjectScorePlusOneExtraPrograms.value);
      return subjectScorePlusOneExtraPrograms.value[plusOneSubjectId.value]; // specific subject (extra programs)
    }
    // All subjects +1 (predicted scores)
    const plusOneUserSubjectGrades = userSubjectGrades.map(usg => ({
      ...usg,
      grade: getFormattedGrade(Math.min(7, getDSEScore({}, usg.grade)+1))?.toString(),
    }));
    return allPrograms.value.filter(p => isAchievableProgram(p, allSubjects, userSubjects, plusOneUserSubjectGrades, 'overallTarget'));
  }
  return allPrograms.value;
});

// Filtered programs (e.g. discipline tags / discipline group tags)
const filteredPrograms = computed(() => {
  if (props.isDemo) {
    //return allPrograms.value.filter(p => [161, 158].includes(Number(p.id)));
    return allPrograms.value.filter(p => [161, 285].includes(Number(p.id)));
  }
  if (searchKeyword.value) {
    return allPrograms.value.filter(p => {
      const targetText = `${p.name.toLowerCase()} ${(p.jupasCode || '').toLowerCase()}`;
      return targetText.includes(searchKeyword.value.toLowerCase().trim());
    });
  }
  if (['like', 'dislike'].includes(selectedOption.value)) {
    return userPrograms.value.filter(ue => ue.reaction == selectedOption.value).map(ue => {
      return allPrograms.value.find(e => e.id == ue.programId);
    });
  }
  let res = achievablePrograms.value; // Set: achievable programs
  if (selectedOption.value == 'highlight') {
    //res = allPrograms.value.filter(p => p.sortOrder != 99999).sort((a,b) => (a.sortOrder-b.sortOrder)); // featured programs
    res = res.filter(p => p.sortOrder != 99999).sort((a,b) => (a.sortOrder-b.sortOrder)); // featured programs
  }
  else if (selectedFilterGroup.value == 'institutions' && selectedOption.value.id) {
    res = res.filter(p => p.institutionId == selectedOption.value.id); // filter by institutions
    if (nestedOption.value != 'all') {
      res = res.filter(p => p.disciplines.some(d => d.disciplineGroupId?.toString() == nestedOption.value)); // further filter by discipline groups
    }
  }
  else if (selectedFilterGroup.value == 'disciplines' && selectedOption.value.id) {
    res = res.filter(p => p.disciplines.some(d => d.disciplineGroupId?.toString() == selectedOption.value.id)); // filter by discipline groups
    if (nestedOption.value != 'all') {
      res = res.filter(p => p.disciplines.some(d => d.id == nestedOption.value)); // further filter by disciplines
    }
  }
  return [
    ...res.filter(d => !isDisliked(d)),
    ...res.filter(d => isDisliked(d)),
  ];
});

// swiper
const modules = [EffectCards, Navigation, Virtual, IonicSlides];

// Program competition
const getCompetitivenessColor = (ratio: any) => {
  if (ratio <= 6) {  // Bottom 35-40% - Less competitive
    return 'success';
  } else if (ratio <= 20) {  // Middle 45-60% - Moderately competitive
    return 'warning';
  } else {  // Top 15-20% - Highly competitive
    return 'danger';
  }
}

// Program Elective Requirements
const passProgramElectiveRequirements = (program) => {
  const { allSubjects } = store.state;
  const userObj = props.targetUser || user.value;
  const userSubjects = getUserSubjects(allSubjects, userObj);
  const userSubjectGrades = userObj.userSubjectGrades || [];
  return isMeetProgramElectiveRequirements(program, allSubjects, userSubjects, userSubjectGrades, 'overallTarget');
}

// Advertisements (assume 1 discipline / discipline group only 1 client)
const relatedAdvBanner = computed(() => {
  return advertisements.value.find(ad => {
    if (nestedOption.value != 'all') return ad.disciplineId == nestedOption.value; // Discipline
    return ad.disciplineGroupId == selectedOption.value.id; // Discipline Group
  });
})

// Access score component child
const getColorForScore = (program) => {
  if (selectedPredictScoreFilter.value == 'achievableSelfPredict+1') {
    return 'green';
  }
  const { allSubjects } = store.state;
  const userObj = props.targetUser || user.value;
  const userSubjects = getUserSubjects(allSubjects, userObj);
  const userSubjectGrades = userObj.userSubjectGrades || [];
  const source = 'overallTarget'; // use student target

  const passUniEntranceRequirements = isMeetUniEntranceRequirements(userSubjectGrades.filter(sg => sg.source == source));
  const passProgramElectiveRequirements = isMeetProgramElectiveRequirements(program, allSubjects, userSubjects, userSubjectGrades, source);
  const { notMeetMinGradeSubjects, } = calculateSumWeightedScores(allSubjects, userSubjects, userSubjectGrades, program, source);

  if (notMeetMinGradeSubjects.length > 0 || !passUniEntranceRequirements) return 'fdmtred';
  if (!passProgramElectiveRequirements) return 'medium';
  const scoreDiff = getScoreDiff(program, allSubjects, userSubjects, userSubjectGrades, source);
  if (scoreDiff == null) return 'light';
  if (scoreDiff >= 0) return 'darkgreen';
  return 'fdmtred';
}

// Program count by disciplines / discipline groups / institutions
const numOfAchievableProgramsByDiscipline = (disciplineId: string) => {
  return achievablePrograms.value.filter(p => p.disciplines.some(d => d.id == disciplineId)).length;
}
const numOfAchievableProgramsByDisciplineGroup = (disciplineGroupId: string) => {
  return achievablePrograms.value.filter(p => p.disciplines.some(d => d.disciplineGroupId?.toString() == disciplineGroupId)).length;
}
const numOfAchievableProgramsByInstitution = (institutionId: string) => {
  return achievablePrograms.value.filter(p => p.institutionId == institutionId).length;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        (__props.isAB3 || !__props.singleSelectMode)
          ? (_openBlock(), _createBlock(_unref(IonToolbar), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButtons), { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButton), {
                      slot: "icon-only",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmSelect(true)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonTitle), { style: {"padding-left":"16px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        (__props.isAB3)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [
                              _createElementVNode("b", null, [
                                _createElementVNode("span", _hoisted_2, [
                                  _createVNode(_unref(IonIcon), { icon: _unref(thumbsUpOutline) }, null, 8, ["icon"])
                                ]),
                                _cache[13] || (_cache[13] = _createTextVNode("  2+ programs"))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                              _createElementVNode("b", null, [
                                _createElementVNode("span", _hoisted_4, [
                                  _createVNode(_unref(IonIcon), { icon: _unref(thumbsUpOutline) }, null, 8, ["icon"])
                                ]),
                                _cache[14] || (_cache[14] = _createTextVNode("  20 programs"))
                              ])
                            ])),
                        (__props.targetDiscipline)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "for " + _toDisplayString(__props.targetDiscipline?.name), 1))
                          : (!__props.isAB3)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(chosenPrograms.value.length) + "/20 selected", 1))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (takenActions.value)
                  ? (_openBlock(), _createBlock(_unref(IonButtons), {
                      key: 0,
                      slot: "end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonButton), {
                          fill: "solid",
                          color: "success",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmSelect()))
                        }, {
                          default: _withCtx(() => [
                            _cache[15] || (_cache[15] = _createTextVNode(" Save ")),
                            _createVNode(_unref(IonIcon), {
                              slot: "end",
                              icon: _unref(checkmark)
                            }, null, 8, ["icon"])
                          ]),
                          _: 1,
                          __: [15]
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(IonToolbar), {
              key: 1,
              style: {"--min-height":"24px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButtons), { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButton), {
                      slot: "icon-only",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (confirmSelect(true)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonButton), {
                  expand: "block",
                  color: "medium",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (undefined), ["stop"]),
                  href: loggedInUser.value?.waGroupLink,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      icon: _unref(flagOutline)
                    }, null, 8, ["icon"]),
                    _cache[16] || (_cache[16] = _createTextVNode(" 有唔妥？即時cap圖/錄音俾我哋！ ")),
                    _createVNode(_unref(IonIcon), {
                      slot: "end",
                      icon: _unref(logoWhatsapp)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1,
                  __: [16]
                }, 8, ["href"])
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { fullscreen: true }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSearchbar), {
              id: "keyword-searchbar",
              style: {"padding-bottom":"1px"},
              mode: "md",
              modelValue: searchKeyword.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchKeyword).value = $event)),
              placeholder: _unref(t)('search'),
              onIonFocus: _cache[4] || (_cache[4] = ($event: any) => (isSearching.value = true)),
              onIonCancel: _cache[5] || (_cache[5] = ($event: any) => {isSearching.value = false; selectedFilterGroup.value = 'disciplines'}),
              onKeyup: _cache[6] || (_cache[6] = _withKeys((e) => e.target.blur(), ["enter"])),
              "show-cancel-button": "always"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 512), [
          [_vShow, isSearching.value]
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!delayLoading.value && filteredPrograms.value.length > 0)
            ? (_openBlock(), _createBlock(_unref(Swiper), {
                key: 0,
                class: "program-slides",
                id: "card-swiper-slides",
                grabCursor: true,
                navigation: true,
                modules: modules,
                virtual: { enabled: true }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPrograms.value, (program) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      class: "program-slide",
                      key: program.id,
                      "data-program-id": program.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["program-slide-upper-section", { 'highlighted-border': isSelected(program) }]),
                          style: _normalizeStyle({ 'background-color': `var(--ion-color-${getColorForScore(program)}` })
                        }, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(ProgramInfoStats, {
                              transparent: true,
                              program: program,
                              showProgramAdmissionData: true,
                              showNames: false,
                              targetUser: __props.targetUser
                            }, null, 8, ["program", "targetUser"])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(SubjectScoreInputSection, {
                              title: __props.targetUser ? 'Student Prediction' : 'My Prediction',
                              source: "overallTarget",
                              targetUser: __props.targetUser,
                              program: program,
                              readonly: !!__props.targetUser,
                              fromDeckView: true,
                              hidePredictedScoreInputs: true,
                              showingPlusOneSection: selectedPredictScoreFilter.value == 'achievableSelfPredict+1'
                            }, null, 8, ["title", "targetUser", "program", "readonly", "showingPlusOneSection"])
                          ]),
                          _createVNode(ProgramInfoStats, {
                            program: program,
                            showProgramAdmissionData: false,
                            showNames: false,
                            targetUser: __props.targetUser
                          }, null, 8, ["program", "targetUser"]),
                          _createVNode(ProgramItemContent, {
                            hideNames: true,
                            item: program,
                            fromDeckView: true,
                            hideDisciplineBadges: true,
                            showRecommendedEvents: false
                          }, null, 8, ["item"]),
                          _createVNode(_unref(IonItem), {
                            lines: "none",
                            style: {"--background":"transparent","margin-top":"2px"}
                          }, {
                            default: _withCtx(() => [
                              (!__props.readonly)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    (__props.singleSelectMode && isSelected(program) && program.id != __props.showFirstProgramId)
                                      ? (_openBlock(), _createBlock(_unref(IonFabButton), {
                                          key: 0,
                                          style: {"margin":"0 auto"},
                                          size: "small",
                                          color: "primary"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(getBandLabel)(chosenPrograms.value.findIndex(p => p.id == program.id))), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : (_openBlock(), _createBlock(_unref(IonFabButton), _mergeProps({
                                          key: 1,
                                          style: {"margin":"0 auto"},
                                          size: "small",
                                          color: "primary"
                                        }, _toHandlers({ [_unref(isMobileWeb)() ? 'touchstart' : 'click']: () => { onThumbsUp(program) } }), {
                                          disabled: !passProgramElectiveRequirements(program)
                                        }), {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonIcon), {
                                              icon: isSelected(program) ? _unref(thumbsUp) : _unref(thumbsUpOutline)
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1040, ["disabled"]))
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(IonLabel), { class: "ion-text-center" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("small", _hoisted_11, [
                                    _createElementVNode("span", null, _toDisplayString(program?.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_unref(IonButtons), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonButton), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), {
                                        slot: "icon-only",
                                        icon: undefined
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024)
                        ], 6)
                      ]),
                      _: 2
                    }, 1032, ["data-program-id"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(IonModal), {
          "is-open": showReportModal.value,
          onDidDismiss: _cache[7] || (_cache[7] = ($event: any) => (showReportModal.value = false))
        }, {
          default: _withCtx(() => [
            (selectedProgramForReport.value)
              ? (_openBlock(), _createBlock(ProgramIssueReportModal, {
                  key: 0,
                  program: selectedProgramForReport.value
                }, null, 8, ["program"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["is-open"])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), {
          class: "material-div",
          style: {"height":"auto","padding-bottom":"8px"}
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonChip), {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (selectedOption.value = 'dislike')),
                  class: _normalizeClass({ 'active-tag': selectedOption.value == 'dislike' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      color: selectedOption.value == 'dislike' ? 'light' : 'dark',
                      style: {"margin-inline-start":"0"},
                      icon: _unref(thumbsDownOutline)
                    }, null, 8, ["color", "icon"])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_unref(IonChip), {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (selectedOption.value = 'like')),
                  class: _normalizeClass({ 'active-tag': selectedOption.value == 'like' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      color: selectedOption.value == 'like' ? 'light' : 'dark',
                      style: {"margin-inline-start":"0"},
                      icon: _unref(thumbsUpOutline)
                    }, null, 8, ["color", "icon"])
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }, 512), [
              [_vShow, selectedFilterGroup.value == 'myChoices']
            ]),
            _withDirectives(_createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                (user.value.isAdmin && relatedAdvBanner.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (!relatedAdvBanner.value.bannerImgLink)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Your department's advertisement "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("a", {
                              href: relatedAdvBanner.value.link,
                              target: "_blank"
                            }, [
                              _createElementVNode("img", {
                                src: _unref(getProxyImgLink)(relatedAdvBanner.value.bannerImgLink)
                              }, null, 8, _hoisted_16)
                            ], 8, _hoisted_15)
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (selectedOption.value.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disciplines.value.filter(d => d.disciplineGroupId == selectedOption.value.id), (dis) => {
                        return _withDirectives((_openBlock(), _createBlock(_unref(IonChip), {
                          outline: "",
                          key: dis.id,
                          onClick: ($event: any) => (nestedOption.value = dis.id),
                          class: _normalizeClass([{ 'active-tag': nestedOption.value == dis.id }, "compact-chip"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(dis.name) + " (" + _toDisplayString(numOfAchievableProgramsByDiscipline(dis.id)) + ")", 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "class"])), [
                          [_vShow, numOfAchievableProgramsByDiscipline(dis.id) > 0]
                        ])
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  (!__props.isAB3)
                    ? (_openBlock(), _createBlock(_unref(IonChip), {
                        key: 0,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (selectedOption.value = 'highlight')),
                        class: _normalizeClass([{ 'active-tag': selectedOption.value == 'highlight' }, "compact-chip"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode("Highlight")
                            ])),
                            _: 1,
                            __: [17]
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disciplineGroups.value, (dg) => {
                    return (_openBlock(), _createBlock(_unref(IonChip), {
                      key: dg.id,
                      onClick: ($event: any) => (selectedOption.value = dg),
                      class: _normalizeClass([{ 'active-tag': selectedOption.value.id == dg.id }, "compact-chip"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(dg.name) + " (" + _toDisplayString(numOfAchievableProgramsByDisciplineGroup(dg.id)) + ")", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 512), [
              [_vShow, selectedFilterGroup.value == 'disciplines']
            ]),
            _withDirectives(_createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disciplineGroups.value, (dg) => {
                    return _withDirectives((_openBlock(), _createBlock(_unref(IonChip), {
                      outline: "",
                      key: dg.id,
                      onClick: ($event: any) => (nestedOption.value = dg.id),
                      class: _normalizeClass({ 'active-tag': nestedOption.value == dg.id })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(dg.name) + " (" + _toDisplayString(numOfAchievableProgramsByDisciplineGroup(dg.id)) + ")", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"])), [
                      [_vShow, numOfAchievableProgramsByDisciplineGroup(dg.id) > 0]
                    ])
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedInstitutions.value, (inst) => {
                    return (_openBlock(), _createBlock(_unref(IonChip), {
                      key: inst.id,
                      onClick: ($event: any) => (selectedOption.value = inst),
                      class: _normalizeClass({ 'active-tag': selectedOption.value.id == inst.id })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(inst.nameShort) + " (" + _toDisplayString(numOfAchievableProgramsByInstitution(inst.id)) + ")", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 512), [
              [_vShow, selectedFilterGroup.value == 'institutions']
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonToolbar), { style: {"--min-height":"24px"} }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSegment), {
              class: "filter-group-segment",
              mode: "ios",
              modelValue: selectedFilterGroup.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedFilterGroup).value = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                (!__props.targetDiscipline)
                  ? (_openBlock(), _createBlock(_unref(IonSegmentButton), {
                      key: 0,
                      value: "disciplines"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode("Disciplines")
                          ])),
                          _: 1,
                          __: [18]
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonSegmentButton), { value: "institutions" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createTextVNode("Institutions")
                      ])),
                      _: 1,
                      __: [19]
                    })
                  ]),
                  _: 1
                }),
                (!__props.singleSelectMode && userPrograms.value.some(ud => ud.reaction == 'like'))
                  ? (_openBlock(), _createBlock(_unref(IonSegmentButton), {
                      key: 1,
                      value: "like"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          size: "small",
                          icon: _unref(thumbsUpOutline)
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonSegmentButton), { value: "search" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonRippleEffect)),
                    _createVNode(_unref(IonIcon), {
                      size: "small",
                      icon: _unref(search)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonToolbar), { style: {"margin-top":"0px","--min-height":"36px"} }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSegment), {
              class: "predicted-score-filters",
              mode: "ios",
              scrollable: "",
              modelValue: selectedPredictScoreFilter.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedPredictScoreFilter).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonSegmentButton), { value: "all" }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("All")
                  ])),
                  _: 1,
                  __: [20]
                }),
                _createVNode(_unref(IonSegmentButton), { value: "achievableSelfPredict" }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("Achievable"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode("(self-predict)")
                  ])),
                  _: 1,
                  __: [21]
                }),
                _createVNode(_unref(IonSegmentButton), { value: "achievableSelfPredict+1" }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("Achievable"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode("(self-predict + 1)")
                  ])),
                  _: 1,
                  __: [22]
                }),
                _createVNode(_unref(IonSegmentButton), {
                  value: "achievableSchoolPredict",
                  disabled: __props.targetUser == null
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("Achievable"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode("(school-predict)")
                  ])),
                  _: 1,
                  __: [23]
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (selectedPredictScoreFilter.value != 'achievableSelfPredict+1')
          ? (_openBlock(), _createBlock(_unref(IonToolbar), {
              key: 0,
              color: "primary",
              class: "ion-text-center",
              style: {"--min-height":"48px","font-size":"24px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("b", null, _toDisplayString(achievablePrograms.value.length), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(SubjectScoreInputSection, {
          targetUser: __props.targetUser,
          showSubjectNamesOnly: true,
          subjectScorePlusOneExtraPrograms: subjectScorePlusOneExtraPrograms.value,
          showScorePlusOneSection: selectedPredictScoreFilter.value == 'achievableSelfPredict+1',
          onPlusOneSubjectIdChanged: plusOneSubjectIdChanged
        }, null, 8, ["targetUser", "subjectScorePlusOneExtraPrograms", "showScorePlusOneSection"]),
        _createVNode(SubjectScoreInputSection, {
          targetUser: __props.targetUser,
          title: __props.targetUser ? 'Student Prediction' : 'My Prediction',
          source: "overallTarget",
          hideSubjectNames: true,
          readonly: !!__props.targetUser,
          noBottomBorderRadius: true,
          noTopBorderRadius: true,
          gradeSelectLargeFont: true,
          smallTitles: true,
          useBlueBackground: true
        }, null, 8, ["targetUser", "title", "readonly"]),
        _createVNode(SubjectScoreInputSection, {
          targetUser: __props.targetUser,
          title: "School Prediction",
          source: "schoolPredict",
          hideSubjectNames: true,
          readonly: !__props.targetUser,
          noBottomBorderRadius: true,
          noTopBorderRadius: true,
          gradeSelectLargeFont: true,
          smallTitles: true,
          useBlueBackground: true
        }, null, 8, ["targetUser", "readonly"])
      ]),
      _: 1
    }, 512), [
      [_vShow, !isSearching.value]
    ])
  ], 64))
}
}

})